export default __webpack_public_path__ + "static/media/Delete.20787624.svg";